interface ProgressBarProps {
  value: number;
  max?: number;
  label?: string;
  showValue?: boolean;
  colorThresholds?: { warning: number; danger: number };
  className?: string;
}

export default function ProgressBar({
  value,
  max = 100,
  label,
  showValue = true,
  colorThresholds = { warning: 0.7, danger: 0.9 },
  className = '',
}: ProgressBarProps) {
  const percentage = Math.min((value / max) * 100, 100);
  const ratio = value / max;

  let colorClass = 'bg-success';
  if (ratio >= colorThresholds.danger) {
    colorClass = 'bg-danger';
  } else if (ratio >= colorThresholds.warning) {
    colorClass = 'bg-warning';
  }

  return (
    <div className={className}>
      {(label || showValue) && (
        <div className="flex justify-between text-sm mb-1">
          {label && <span className="text-gray-400">{label}</span>}
          {showValue && (
            <span className="text-gray-300">
              {typeof value === 'number' && value < 0 ? '-' : ''}
              ${Math.abs(value).toFixed(0)} / ${max}
            </span>
          )}
        </div>
      )}
      <div className="progress-bar">
        <div
          className={`progress-fill ${colorClass}`}
          style={{ width: `${percentage}%` }}
        />
      </div>
    </div>
  );
}
